import classNames from 'classnames';
import { FunctionComponent } from 'react';
import { Nullable } from 'types/util/Nullable';
import DashboardCard, { IDashboardCardProps } from '../DashboardCard/DashboardCard';
import DashboardCardHeader, { IDashboardCardHeaderProps } from '../DashboardCardHeader/DashboardCardHeader';
import DashboardCardWarningBanner from '../DashboardCardWarningBanner/DashboardCardWarningBanner';
import './DashboardContentCard.scss';

interface IDashboardContentCardProps
  extends Omit<IDashboardCardProps, 'showBlurredBackground'>,
    Omit<IDashboardCardHeaderProps, 'className'> {
  warningDetails?: Nullable<{
    text: string;
    onClick?: () => void;
  }>;
}

const DashboardContentCard: FunctionComponent<IDashboardContentCardProps> = ({
  className,
  theme,
  children,
  rightLabel,
  onRightLabelClick,
  header,
  subheaderValue,
  divider,
  warningDetails,
  ...cardProps
}) => {
  const classes = classNames('dashboard-content-card', className);

  const headerMargin = divider ? 'mb-5' : 'mb-8';

  return (
    <DashboardCard className={classes} {...cardProps} theme={theme}>
      <div
        className={classNames('dashboard-content-card-container', {
          [`${divider === true ? 'divider' : 'default'}-padding`]: true,
        })}
      >
        <DashboardCardHeader
          rightLabel={rightLabel}
          onRightLabelClick={onRightLabelClick}
          header={header}
          subheaderValue={subheaderValue}
          theme={theme}
          divider={divider}
          className={headerMargin}
        />
        <div className="dashboard-content-card-content">{children}</div>
      </div>
      {warningDetails && (
        <DashboardCardWarningBanner warningText={warningDetails.text} onClick={warningDetails.onClick} />
      )}
    </DashboardCard>
  );
};

export default DashboardContentCard;
